<template>
  <div>
    <div>
      <j-select-biz-component
        :value="value"
        :option="option"
        :name="this.$store.getters.language['role']"
        displayKey="roleName"
        :disabled="disabled"
        :returnKeys="returnKeys"
        :listUrl="listUrl"
        :columns="columns"
        queryParamCode='applicationName'
        :queryParamText='this.$store.getters.language["application.applicationName"]'
        v-on="$listeners"
        v-bind="$attrs"
      />
    </div>
    <div>
      <a-modal
        title="Title"
        :visible="visible"
        :zIndex="1005"
      />


    </div>
    <div>
      <span slot="action" slot-scope="text, record">
          <a >{{this.$store.getters.language['common.edit']}}</a>
        </span>

    </div>
  </div>

</template>

<script>
  import JSelectBizComponent from './JSelectBizComponent'

  export default {
    name: 'JSelectRole',
    components: { JSelectBizComponent },
    props: {
      //'value','option','appId',"disabled"
      value: {
        type: String,
        default: ''
      },
      option:{
        type: Array,
        default: () => []
      },
      listUrl:{
        type:String,
        required:false,
        default:'',
      },
      appId: {
        type: String,
        default: ''
      },
      disabled: {
        type: Boolean,
        default: false
      }

    },
    data() {
      return {
        returnKeys: ['roleName', 'id'],
        visible:false,
        url: { list: '/sys/role/listByApplication?applicationIds='+this.appId },
        columns: [
          { title: this.$store.getters.language['platform.roleUser.columns.roleName'], dataIndex: 'roleName', align: 'center', width: 120 },
          { title: this.$store.getters.language['platform.roleUser.columns.roleCode'], dataIndex: 'roleCode', align: 'center', width: 120 },
          { title: this.$store.getters.language['platform.roleUser.columns.applicationName'], dataIndex: 'applicationName', align: 'center', width: 120 },
          /*{ title: '创建时间', dataIndex: 'createTime', align: 'center', width: 120 },*/

        ]
      }
    }
  }
</script>

<style lang="less" scoped></style>